import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/components/tableStyle";
import {
  Typography,
  Grid,
  Button,
  CardActions,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Divider,
  Chip,
} from "@material-ui/core";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";
import moment from "moment";
import { LOCALE } from "../../properties/Locale";
import { Redirect } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function ActiveVacancyComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [vacancy, setVacancy] = React.useState();
  const [rerender, triggerRerender] = React.useState(false);
  const [expiringTime, setExpiringTime] = React.useState(null);
  const [expiringDays, setExpiringDays] = React.useState(null);
  const [redirect, setRedirect] = React.useState();

  useEffect(() => {
    if (vacancy) {
      setInterval(() => {
        var eventdate = moment(vacancy.endDate);
        var todaysdate = moment();
        setExpiringDays(eventdate.diff(todaysdate, "days"));
      }, 1000);
    }
  }, [vacancy]);

  useEffect(() => {
    if (expiringDays === 0) {
      setInterval(() => {
        var eventdate = moment(vacancy.endDate);
        var todaysdate = moment();
        setExpiringTime(eventdate.diff(todaysdate, "hours"));
      }, 1000);
    }
  }, [expiringDays]);

  useEffect(() => {
    if (props.vacancy) {
      setVacancy(props.vacancy);
    }
  }, []);

  const handleSubmit = () => {
    setRedirect("/app/vacancy-application/" + vacancy.id + "/new");
  };

  return (
    <div>
      {redirect && <Redirect to={redirect} />}

      <Card className={classes.root} href="/brbrb">
        <CardActionArea
          onClick={() => {
            handleSubmit();
          }}
        >
          {!expiringTime && expiringDays && expiringDays > 0 ? (
            <Chip
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
              }}
              label={
                LOCALE.expires_in +
                " " +
                expiringDays +
                " " +
                (expiringDays === 1 ? LOCALE.day : LOCALE.days)
              }
              color="secondary"
              icon={<AccessAlarmIcon />}
            />
          ) : (
            ""
          )}

          {expiringTime ? (
            <Chip
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
              }}
              label={LOCALE.expires_in + " " + expiringTime + "h"}
              color="secondary"
              icon={<AccessAlarmIcon />}
            />
          ) : (
            ""
          )}

          {expiringDays != null && expiringDays <= 0 && expiringTime <= 0 ? (
            <div>
              <Chip
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                }}
                label={LOCALE.application_time_expired}
                color="secondary"
                icon={<AccessAlarmIcon />}
              />
            </div>
          ) : (
            ""
          )}

          <CardMedia
            className={classes.media}
            image={require("../../assets/img/konkurs.png")}
            height="240"
            component="img"
            title="Konkurs"
          />
          <CardContent>
            <div>
              <Grid container>
                <Grid item xs={6}>
                  <Typography gutterBottom variant="h5" component="h2">
                    {vacancy?.name}
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: "right" }}>
                  <Typography gutterBottom variant="h5" component="h2">
                    {LOCALE.getString(vacancy?.vacancyType)}
                  </Typography>
                </Grid>
              </Grid>
              <Divider></Divider>
            </div>
            <Typography
              variant="body1"
              color="textSecondary"
              component="p"
              style={{ marginTop: "10px" }}
            >
              {vacancy?.description}
            </Typography>
          </CardContent>
        </CardActionArea>
        <div style={{ padding: "15px" }}>
          <Grid container>
            <Grid item xs={4}>
              <Typography variant="body2" color="textSecondary" component="p">
                Конкурсот е објавен на:
                {moment(vacancy?.startDate).format(" DD/MM/YYYY")}
              </Typography>
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={4} style={{ textAlign: "right" }}>
              {" "}
              <Typography variant="body2" color="textSecondary" component="p">
                Конкурсот завршува на:
                {moment(vacancy?.endDate).format(" DD/MM/YYYY")}
              </Typography>
            </Grid>
          </Grid>
          <Divider />

          <Grid container style={{ marginTop: "15px" }}>
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Button
                style={{ float: "center" }}
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                onClick={handleSubmit}
              >
                {LOCALE.apply}
              </Button>
            </Grid>{" "}
          </Grid>
        </div>
      </Card>
    </div>
  );
}
